import {
  BUTTON_SIZE,
  BUTTON_TYPE,
  DSBottomSheet,
  DSButton,
  DSModal,
  DSRADIO_BUTTON_POSITION,
  DSRadio,
  DSTextArea,
  Switch,
} from '@repo/design-system/index'
import {
  QIcon_chevron_down,
  QIcon_close_default,
  QIcon_noconversation,
  QIcon_pen,
  QIcon_trash,
} from '@repo/icons/index'
import classNames from 'classnames'
import React, { useEffect, useMemo, useState } from 'react'
import { ANSWER_SHARE_STATUS } from '../../../../model/answer.interface'
import apis from '../../../../modules/apis'
import { axiosDelete, axiosPatch } from '../../../../modules/axiosHelper'
import useAppRouter from '../../../../modules/hooks/common/useAppRouter'
import useIsMobile from '../../../../modules/hooks/common/useIsMobile'
import useIsWebview from '../../../../modules/hooks/common/useIsWebview'
import { LOCALE_EN, LOCALE_KO } from '../../../../modules/i18n/config'
import { n_common, n_lesson_prep } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'
import { COLORS } from '../../../../modules/vars'
import { useLessonsStack } from '../../../../pages/[lang]/webview/lessons'
import Pagination from '../../../common/Pagination'
import { fetchCourseData } from '../QuestionPanel'
import { SHARE_STATUS, shareOptions } from './AnswerItem'
import { fetchData } from './QuestionSelectPanel'
import { useTranslatorSidePopup } from './TranslatorSidePopup'
import ViewAnswerItem from './ViewAnswerItem'

interface MyAnswerHistoryProps {
  isEditable: any
  myAnswers: any
  setMyAnswers: any
  id?: any
  activeQuestionId?: any
}

const MyAnswerHistory = ({ isEditable, myAnswers, setMyAnswers, id, activeQuestionId }: MyAnswerHistoryProps) => {
  const sidePopup = useTranslatorSidePopup()
  const { t, locale } = useTranslation()
  const isMobile = useIsMobile(undefined, 640)
  const isWebview = useIsWebview()
  const [showBottomSheet, setShowBottomSheet] = useState(false)
  const [showPopup, setShowPopup] = useState(false)

  const { useLessonsFlow } = useLessonsStack()
  const { push } = useLessonsFlow()
  const router = useAppRouter({ stackPush: push })
  const isMaterial = useMemo(() => router.asPath.includes('/materials/'), [router.asPath])

  const lessonId = router.query?.lessonId
    ? typeof router.query.lessonId === 'string'
      ? parseInt(router.query.lessonId, 10)
      : 0
    : undefined

  console.log(isEditable)

  // 수정하기 버튼을 눌렀을 때
  const MyAnswerEditModalBody = ({ item, isEditable, lessonId, setMyAnswers, setShowBottomSheet }) => {
    console.log(
      'item ==========>',
      isEditable?.find((item) => item.question_number == activeQuestionId)
    )

    const [inputValue, setInputValue] = useState(item.content)
    const [inputShareStatus, setInputShareStatus] = useState(item.share_status)
    const coursekeyquestion_id = item.coursekeyquestion_id ? item.coursekeyquestion_id : item.id
    const question = isEditable?.find((item) => item.id == coursekeyquestion_id)?.content_main
      ? isEditable?.find((item) => item.id == coursekeyquestion_id)?.content_main
      : isEditable?.find((item) => item.question_number == activeQuestionId)?.content_main
    const question_number = isEditable?.find((item) => item.id == coursekeyquestion_id)?.question_number
    const [saveDisabled, setSaveDisabled] = useState(false)
    const [questionTranslate, setQuestionTranslate] = useState<boolean>(false)
    const [showBottomSheetShare, setShowBottomSheetShare] = useState(false)
    const [showConfirmPopup, setShowConfirmPopup] = useState(false)

    const onClickBottomSheet = () => {
      setShowBottomSheetShare(true)
    }

    const closeBottomSheet = (e) => {
      e.stopPropagation()
      setShowBottomSheetShare(false)
    }

    const handleSidePopupClose = () => {
      console.log(inputValue)

      if (inputValue === item.content) {
        // 하나도 수정하지 않은 경우 - 그냥 닫힘
        sidePopup.close('modify-popup')
        setShowBottomSheet(false)
        return
      } else if (inputValue == '') {
        // 사용자가 기존 작성했던 텍스트를 지우는 경우
        sidePopup.close('modify-popup')
        setShowBottomSheet(false)
        return
      } else {
        setShowPopup(true)
      }
    }

    const handleBottomSheetClose = () => {
      if (inputValue === item.content) {
        // 하나도 수정하지 않은 경우 - 그냥 닫힘
        setShowBottomSheet(false)
        return
      } else if (inputValue == '') {
        // 사용자가 기존 작성했던 텍스트를 지우는 경우
        setShowBottomSheet(false)
        return
      } else {
        setShowConfirmPopup(true)
      }
    }

    const handleModifyAnswer = async () => {
      const payload = {
        content: inputValue,
        share_status: inputShareStatus,
      }

      const response = await axiosPatch(apis.lessons.preparation.patch({ answerId: item.id }), payload)

      if (response) {
        sidePopup.close('modify-popup')
        setShowBottomSheet(false)
        if (!isMaterial) {
          const newData = await fetchData(lessonId)

          if (newData) {
            setMyAnswers(
              newData.lesson?.preparation?.student_answers
                ? newData.lesson?.preparation?.student_answers.filter((item) => item.is_final)
                : []
            )
          }
        } else {
          const newData = await fetchCourseData(id)

          if (newData) {
            setMyAnswers(newData?.filter((item) => item.question_number == activeQuestionId)[0]?.answers?.my_answers)
          }
        }
      }
    }

    useEffect(() => {
      if (inputValue === '') {
        setSaveDisabled(true)
      } else {
        setSaveDisabled(false)
      }
    }, [inputValue])

    return (
      <div className="flex w-full flex-col p-20">
        <div className={classNames([isWebview ? 'justify-end' : 'mt-[20px]'], 'flex items-center pb-[16px]')}>
          {isWebview ? (
            <div>
              <QIcon_close_default onClick={handleBottomSheetClose} />
            </div>
          ) : (
            <>
              <div className="mr-auto"></div>
              <div className="whitespace-normal text-[20px] font-bold text-black" style={{ wordBreak: 'keep-all' }}>
                {t(n_lesson_prep.answer_edit_title)}
              </div>
              <div className="ml-auto">
                <button
                  type="button"
                  className="appearance-none border-none focus:outline-none"
                  style={{ width: 24, height: 24 }}
                  onClick={() => {
                    handleSidePopupClose()
                  }}
                >
                  <QIcon_close_default />
                </button>
              </div>
            </>
          )}
        </div>
        <div>
          <div className="text-h2 mb-[8px] font-bold">
            {isWebview && (locale == LOCALE_KO || locale == LOCALE_EN) ? (
              <>
                <div className="flex">
                  <span className="text-[16px] font-bold text-gray-700">Q1</span>
                  <div className="ml-auto flex items-center space-x-4">
                    <span className="text-14 font-medium text-gray-700">{t(n_lesson_prep.view_kr)}</span>
                    <Switch checked={questionTranslate} setChecked={setQuestionTranslate} />
                  </div>
                </div>
              </>
            ) : (
              <>
                Q{question_number}. {question}
              </>
            )}
          </div>
          {isWebview && (
            <>
              <div className="mb-[8px] text-[16px] font-medium">
                {isEditable.find((item) => item.question_number === question_number)?.content_main}
              </div>
            </>
          )}
          <div>
            <DSTextArea
              name={'TRANSLATE_TEXT_AREA'}
              value={inputValue}
              setValue={setInputValue}
              placeholder={'입력하세요'}
              autoFocus={true}
              customTextClassName={`mb-[40px] min-h-[233px] Body2-14Md`}
            />
            {showConfirmPopup && (
              <MyAnswerCancelPopupWebviewBody
                showPopup={showConfirmPopup}
                setShowPopup={setShowConfirmPopup}
                setShowBottomSheet={setShowBottomSheet}
              />
            )}
          </div>
        </div>
        <div className="pb-24">
          <div className="text-[16px] font-bold text-gray-600">{t(n_lesson_prep.answer_scope)}</div>
          {isWebview ? (
            <div
              onClick={onClickBottomSheet}
              className={classNames(
                'flex w-full flex-row items-center rounded-[8px] border-[1.5px] border-gray-300 bg-white px-[12px] py-[8px]'
              )}
            >
              <span className="text-[16px] font-medium">
                {t(SHARE_STATUS[inputShareStatus ? inputShareStatus : 0])}
              </span>
              <QIcon_chevron_down className="ml-auto h-12 w-12" />
            </div>
          ) : (
            <DSRadio
              controlSelected={[inputShareStatus, setInputShareStatus]}
              buttonPosition={DSRADIO_BUTTON_POSITION.LEFT}
              containerClassName={'flex flex-row space-x-[8px]'}
            >
              <DSRadio.Item value={ANSWER_SHARE_STATUS.PUBLIC}>{t(n_lesson_prep.answer_scope_option1)}</DSRadio.Item>
              <DSRadio.Item value={ANSWER_SHARE_STATUS.ME}>{t(n_lesson_prep.answer_scope_option2)}</DSRadio.Item>
              <DSRadio.Item value={ANSWER_SHARE_STATUS.TUTOR_AND_ME}>
                {t(n_lesson_prep.answer_scope_option3)}
              </DSRadio.Item>
            </DSRadio>
          )}
          {showBottomSheetShare && (
            <DSBottomSheet
              id={`bottom-sheet-${question_number}`}
              isOpen={showBottomSheetShare}
              setIsOpen={setShowBottomSheetShare}
              closeOnDrag
              closeOnDim
            >
              <div className="flex h-full w-full flex-col">
                <div className="mb-[44px] flex flex-col gap-[20px] px-[20px] pt-[4px]">
                  <div className="flex flex-col gap-[16px]">
                    {shareOptions(isMaterial).map((item, index) => (
                      <div key={index} className="flex justify-between">
                        <button
                          className="flex flex-row gap-x-[8px] py-[16px] px-[20px]"
                          onClick={(e) => {
                            closeBottomSheet(e)
                            setInputShareStatus(item.value)
                          }}
                        >
                          {t(item.label)}
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </DSBottomSheet>
          )}
        </div>
        <div className="flex justify-between">
          <DSButton
            onClick={(e) => {
              handleModifyAnswer()
            }}
            size={BUTTON_SIZE.MD}
            customBgColor={COLORS.PURPLE600}
            disabled={saveDisabled}
          >
            <span className="font-bold text-white">{t(n_common.btn_save_full)}</span>
          </DSButton>
        </div>
      </div>
    )
  }

  // 수정 끌 때 팝업
  const MyAnswerCancelPopupBody = ({ showPopup, setShowPopup }) => {
    const sidePopup = useTranslatorSidePopup()
    const handleOnCloseButtonClick = (e) => {
      e.stopPropagation(e)
      setShowPopup(false)
    }

    const handleOnApplyButtonClick = (e) => {
      e.stopPropagation()
      setShowPopup(false)
      sidePopup.close('modify-popup')
    }
    return (
      <DSModal id="TextOnlySMTwoButtonHorizontalPopup" isOpen={showPopup} setIsOpen={setShowPopup} size={'sm'}>
        <DSModal.Title>
          <div className="flex flex-wrap text-[18px]">{t(n_lesson_prep.popup_edit_title)}</div>
        </DSModal.Title>
        <DSModal.Content>{t(n_lesson_prep.popup_edit_info)}</DSModal.Content>
        <DSModal.ButtonContainer direction="horizontal">
          <DSButton
            size={BUTTON_SIZE.MD}
            type={BUTTON_TYPE.OUTLINE}
            customBgColor={COLORS.WHITE}
            onClick={handleOnCloseButtonClick}
          >
            <DSButton.Label>{t(n_common.btn_cancel)}</DSButton.Label>
          </DSButton>
          <DSButton size={BUTTON_SIZE.MD} onClick={handleOnApplyButtonClick}>
            <DSButton.Label>{t(n_common.btn_leave)}</DSButton.Label>
          </DSButton>
        </DSModal.ButtonContainer>
      </DSModal>
    )
  }

  const MyAnswerCancelPopupWebviewBody = ({ showPopup, setShowPopup, setShowBottomSheet }) => {
    const handleOnCloseButtonClick = (e) => {
      e.stopPropagation(e)
      setShowPopup(false)
    }

    const handleOnApplyButtonClick = (e) => {
      e.stopPropagation()
      setShowPopup(false)
      setShowBottomSheet(false)
    }
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-[rgba(0,0,0,0.4)] bg-opacity-50">
        <div className="border-1 m-16 flex flex-col space-y-24 rounded-[12px] border-white bg-white p-32">
          <div className="flex flex-col space-y-12">
            <span className="text-[18px] font-bold text-black">{t(n_lesson_prep.popup_edit_title)}</span>
            <span className="text-[14px] font-medium text-gray-700">{t(n_lesson_prep.popup_edit_info)}</span>
          </div>
          <div className="flex w-full justify-center space-x-8">
            <div className="w-full">
              <DSButton
                size={BUTTON_SIZE.MD}
                type={BUTTON_TYPE.OUTLINE}
                customBgColor={COLORS.WHITE}
                onClick={handleOnCloseButtonClick}
              >
                <DSButton.Label>{t(n_common.btn_cancel)}</DSButton.Label>
              </DSButton>
            </div>
            <div className="w-full">
              <DSButton size={BUTTON_SIZE.MD} onClick={handleOnApplyButtonClick}>
                <DSButton.Label>{t(n_common.btn_leave)}</DSButton.Label>
              </DSButton>
            </div>
          </div>
        </div>
      </div>
    )
  }

  // 답변 수정하기 팝업 열기
  const handleMyAnswerModifyButton = ({ e, item }) => {
    console.log(item)

    e.preventDefault()
    if (!isWebview) {
      sidePopup.show({
        id: 'modify-popup',
        overlayClose: false,
        noTopSide: true,
        hFull: true,
        maxW: 448,
        body: (
          <MyAnswerEditModalBody
            item={item}
            isEditable={isEditable}
            lessonId={lessonId ? lessonId : id}
            setMyAnswers={setMyAnswers}
            setShowBottomSheet={setShowBottomSheet}
          />
        ),
      })
    } else {
      setCurrentAnswerItem(item)
      setShowBottomSheet(true)
    }
  }

  // 답변 삭제
  // 이거 끝나고 setMyAnswers fetchData
  const [showDeletePopup, setShowDeletePopup] = useState(false)
  const MyAnswerDeletePopupBody = ({ showPopup, setShowPopup, answerId, setMyAnswers }) => {
    const handleOnCloseButtonClick = (e) => {
      e.stopPropagation(e)
      setShowPopup(false)
    }

    const handleOnApplyButtonClick = async (e) => {
      e.stopPropagation()

      // api call
      const response = await axiosDelete(apis.lessons.preparation.delete({ answerId }))
      if (response) {
        setShowPopup(false)
        sidePopup.close('modify-popup')

        // fetchData
        // 데이터를 바꾸는 작업 필요
        // 여기 lessonId
        if (!isMaterial) {
          const newData = await fetchData(lessonId != undefined ? lessonId : id)

          if (newData) {
            setMyAnswers(
              newData.lesson?.preparation?.student_answers
                ? newData.lesson?.preparation?.student_answers.filter((item) => item.is_final)
                : []
            )
          }
        } else {
          const newData = await fetchCourseData(id)

          if (newData) {
            setMyAnswers(newData?.filter((item) => item.question_number == activeQuestionId)[0]?.answers?.my_answers)
          }
        }
      }
    }
    return (
      <DSModal id="TextOnlySMTwoButtonHorizontalPopup" isOpen={showPopup} setIsOpen={setShowPopup} size={'sm'}>
        <DSModal.Title>
          <div className="flex flex-wrap text-[18px]">{t(n_lesson_prep.popup_delete_title)}</div>
        </DSModal.Title>
        <DSModal.ButtonContainer direction="horizontal">
          <DSButton
            size={BUTTON_SIZE.MD}
            type={BUTTON_TYPE.OUTLINE}
            customBgColor={COLORS.WHITE}
            onClick={handleOnCloseButtonClick}
          >
            <DSButton.Label>{t(n_common.btn_cancel)}</DSButton.Label>
          </DSButton>
          <DSButton size={BUTTON_SIZE.MD} onClick={handleOnApplyButtonClick}>
            <DSButton.Label>{t(n_common.btn_delete)}</DSButton.Label>
          </DSButton>
        </DSModal.ButtonContainer>
      </DSModal>
    )
  }

  const optionList = ({ item }) => [
    {
      title: t(n_lesson_prep.answer_edit_title),
      icon: <QIcon_pen />,
      onClick: (e) => {
        handleMyAnswerModifyButton({ e, item })
      },
    },
    {
      title: t(n_lesson_prep.answer_menu_delete),
      icon: <QIcon_trash />,
      onClick: (e) => {
        setShowDeletePopup(true)
        setCurrentAnswerItem(item)
      },
    },
  ]

  const postsPerPage = 4
  const totalPosts = myAnswers?.length
  const [activeIndex, setActiveIndex] = useState(0)
  const handlePagination = (number) => {
    setActiveIndex(number - 1)
  }

  const startIndex = activeIndex * postsPerPage
  const endIndex = startIndex + postsPerPage
  const currentAnswers = myAnswers?.slice(startIndex, endIndex)
  const [currentAnswerItem, setCurrentAnswerItem] = useState(currentAnswers?.length >= 1 ? currentAnswers[0] : {})

  console.log(currentAnswerItem)

  return (
    <div className="mt-[20px] h-full flex-col space-y-8 sm:mt-0">
      {currentAnswers?.length > 0 &&
        currentAnswers?.reverse().map((item, i) => (
          <div key={i}>
            {i !== 0 && <div style={{ height: 1 }} className="m-16 bg-gray-200"></div>}
            <ViewAnswerItem
              item={item}
              optionList={optionList({ item })}
              customClassName={isMobile ? 'border-[1px] rounded-[8px] border-gray-200 p-[16px]' : ''}
            />
            <MyAnswerDeletePopupBody
              showPopup={showDeletePopup}
              setShowPopup={setShowDeletePopup}
              answerId={currentAnswerItem?.id}
              setMyAnswers={setMyAnswers}
            />
            {showBottomSheet && (
              <DSBottomSheet
                id={`bottom-sheet-${currentAnswerItem?.id}`}
                isOpen={showBottomSheet}
                setIsOpen={setShowBottomSheet}
              >
                <MyAnswerEditModalBody
                  item={currentAnswerItem}
                  isEditable={isEditable}
                  lessonId={lessonId ? lessonId : id}
                  setMyAnswers={setMyAnswers}
                  setShowBottomSheet={setShowBottomSheet}
                />
              </DSBottomSheet>
            )}
            {!isWebview && <MyAnswerCancelPopupBody showPopup={showPopup} setShowPopup={setShowPopup} />}
          </div>
        ))}
      {myAnswers?.length < 1 && (
        <div className="mt-120 flex flex-col items-center justify-center space-y-20">
          <QIcon_noconversation className="h-64 w-64 text-gray-300" />
          <div className="fot-bold text-20 text-black">{t(n_lesson_prep.answer_blank_desc)}</div>
        </div>
      )}
      {myAnswers?.length > 4 && (
        <div className="flex flex-row items-center justify-center gap-[8px] px-[20px] pb-[20px]">
          <Pagination
            postsPerPage={postsPerPage}
            totalPosts={totalPosts}
            paginate={handlePagination}
            activeIndex={activeIndex}
            setActiveIndex={setActiveIndex}
          />
        </div>
      )}
    </div>
  )
}

export default React.memo(MyAnswerHistory)
